import Link from '@/_application/core/components/ui/link';
import {getCategoryUrl} from '@/_application/modules/categories/models/url';
import {CategoryTree} from '__generated__/__types__';
import cn from 'classnames';

interface IProps {
    categoryLevel2: CategoryTree;
    isHeader: boolean;
    parentLength?: number;
}

function SidebarCategoryLevel3List({categoryLevel2, isHeader, parentLength = 0}: Readonly<IProps>) {
    const isLargeList = parentLength <= 3 && categoryLevel2?.children?.length! > 8;

    return (
        <div
            className={cn(
                'sidebar-level3-scrollbar w-full flex-col items-center overflow-auto text-[0.75rem] font-normal',
                {
                    'h-[68px]': categoryLevel2?.children?.length! > 5 && !isLargeList,
                    'h-[220px]': isLargeList,
                },
            )}>
            <ul
                className={cn('grid w-full pr-2', {
                    'gap-1': isHeader,
                    'gap-2': !isHeader,
                })}>
                {categoryLevel2?.children?.map(categoryLevel3 => {
                    if (!categoryLevel3) {
                        return <></>;
                    }
                    return (
                        <li key={categoryLevel3.id} className="text-KPZ_text_1st hover:text-primary">
                            <Link href={getCategoryUrl(categoryLevel3)}>{categoryLevel3.name}</Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default SidebarCategoryLevel3List;
